import { Component, Input } from '@angular/core';
import { IremboPaginationComponent } from '../irembo-pagination/irembo-pagination.component';

@Component({
  standalone: false,
  selector: 'irembogov-data-table-pagination',
  templateUrl: './irembo-data-table-pagination.component.html',
  styleUrls: ['./irembo-data-table-pagination.component.scss'],
})
export class IremboDataTablePaginationComponent extends IremboPaginationComponent {
  @Input() disabled = false;
  @Input() override pageSize = 10;
}
